import { useEffect, useRef } from "react";
import { styles } from "../styles";

/**
 * Lightweight drawn-signature pad (no external library). Draws with mouse,
 * finger, or stylus via pointer events and reports the PNG data URL through
 * onChange whenever a stroke ends or the pad is cleared.
 */
export default function SignaturePad({ onChange, width = 300, height = 120 }) {
  const canvasRef = useRef(null);
  const drawing = useRef(false);

  useEffect(() => {
    const ctx = canvasRef.current.getContext("2d");
    ctx.lineWidth = 2;
    ctx.lineCap = "round";
    ctx.strokeStyle = "#111";
  }, []);

  const pos = (e) => {
    const rect = canvasRef.current.getBoundingClientRect();
    return { x: e.clientX - rect.left, y: e.clientY - rect.top };
  };

  const start = (e) => {
    drawing.current = true;
    const ctx = canvasRef.current.getContext("2d");
    const { x, y } = pos(e);
    ctx.beginPath();
    ctx.moveTo(x, y);
  };

  const move = (e) => {
    if (!drawing.current) return;
    const ctx = canvasRef.current.getContext("2d");
    const { x, y } = pos(e);
    ctx.lineTo(x, y);
    ctx.stroke();
  };

  const end = () => {
    if (!drawing.current) return;
    drawing.current = false;
    onChange(canvasRef.current.toDataURL("image/png"));
  };

  const clear = () => {
    const c = canvasRef.current;
    c.getContext("2d").clearRect(0, 0, c.width, c.height);
    onChange("");
  };

  return (
    <div>
      <canvas
        ref={canvasRef}
        width={width}
        height={height}
        style={{
          border: "1px solid #999",
          borderRadius: "4px",
          touchAction: "none",
          background: "#fff",
          display: "block",
        }}
        onPointerDown={start}
        onPointerMove={move}
        onPointerUp={end}
        onPointerLeave={end}
      />
      <button
        type="button"
        style={{ ...styles.button, padding: "2px 8px", marginTop: "2px" }}
        onClick={clear}
      >
        Clear
      </button>
    </div>
  );
}
